import parsePhoneNumber from 'libphonenumber-js/max';

export const parsePhoneFormatNational = phone => parsePhoneNumber(phone)?.formatNational();
export const parsePhoneFormatInternational = phone => parsePhoneNumber(phone)?.formatInternational();
export const parsePhoneInternational = (phone, countryCode) =>
  parsePhoneNumber(phone, { defaultCountry: countryCode, extract: false })?.number;
